

























import Vue from "vue";
export default Vue.extend({
  name: "CreateApp",
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    show() {
      this.dialog = true;
    },
    quit() {
      this.dialog = false;
    },
    submit(type: string) {
      if (type === "custom") {
        this.$emit("createCustom");
        this.dialog = false;
      } else {
        this.$emit("createTem");
        this.dialog = false;
      }
    }
  }
});
